import { render, staticRenderFns } from "./PartnerInfoUpload.vue?vue&type=template&id=10e69842"
import script from "./PartnerInfoUpload.vue?vue&type=script&lang=js"
export * from "./PartnerInfoUpload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports